import script from "./FamilyGroupMemberModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./FamilyGroupMemberModal.vue?vue&type=script&lang=ts&setup=true"

import "./FamilyGroupMemberModal.vue?vue&type=style&index=0&id=9366fd3c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9366fd3c"]])

export default __exports__